import Nutzungsinfos from "./Nutzungsinfos";




function BlockedPage({ isEligible, isLoggedIn, usageCount, availableUses }) {

  return <Nutzungsinfos isEligible={isEligible} isLoggedIn={isLoggedIn} usageCount={usageCount} availableUses={availableUses} />;
}

export default BlockedPage;